import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { CreateTokenError } from 'src/app/shared/components/payments';

/**
 * @docs https://docs.dlocal.com/docs/using-dlocal-direct#common-5xx-and-4xx-status-codes
 */
export function useDLocalMapHttpError(): (dlocalError: CreateTokenError) => string {
	const { translate } = useI18n();

	return useCallback(
		(dlocalError: CreateTokenError): string => {
			const code = dlocalError.error?.code;
			if (code && code === 404) {
				return translate('corgi.payments.dlocal.errors.api_connection_error');
			}
			return translate('corgi.payments.dlocal.errors.processing_error');
		},
		[translate],
	);
}
